import {
    INIT_SOCKET_HANDLER,
    SET_SOCKET_CONNECTED,
    SET_SOCKET_CONNECTION_COUNTER,
    SET_SOCKET_CONTEXT,
    SET_WINDOW_VISIBLE,
} from '../actions/types';

const initialState = {
    socket: null,
    isWindowVisible: false,
    isSocketConnected: false,
    connectionCounter: 0,
    context: {
        userId: '',
        client: 'ssbt',
        isLive: null,
        isESports: null,
        isOutrights: false,
        events: [],
        betLines: [],
        allMarketsEventId: '',
    },
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case INIT_SOCKET_HANDLER:
            return { ...state, socket: payload };
        case SET_WINDOW_VISIBLE:
            return { ...state, isWindowVisible: payload };
        case SET_SOCKET_CONNECTED: {
            return { ...state, isSocketConnected: payload };
        }
        case SET_SOCKET_CONTEXT:
            return { ...state, context: { ...state.context, ...payload } };
        case SET_SOCKET_CONNECTION_COUNTER:
            return { ...state, connectionCounter: payload };
        default:
            return state;
    }
}
